import { Row, Col, Button, Image } from "react-bootstrap";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";

import votingBanner from "../../assets/images/voting_banner_1.png";

import styles from "./VoteHeaderContent.module.css";

const scrollToSection = () => {
  scroller.scrollTo("homePageVotingSection", {
    //check Voting.js to find this class
    duration: 300,
    delay: 0,
    smooth: "easeInOutQuart",
  });
};

function VoteHeaderContent() {
  const { height, width } = useWindowDimensions();
  return (
    <Row className={styles.ContentContainer}>
      <Col className="d-flex align-items-center">
        <div>
          <div className={styles.headerTitle}>YOUR VOTE MATTERS</div>
          <div className={styles.headerSubtext}>
            Voton allows you to help organizations and individuals to raise
            funds by voting for the project proposals you wish to support.
          </div>
          <Button
            className={styles.headerButtons}
            onClick={() => scrollToSection()}
          >
            <div className={styles.headerButtonText}>Vote Now</div>
          </Button>
          {width < 992 ? (
            <Col>
              <Link to="buy-voton">
                <Button
                  className={styles.headerButtons}
                  onClick={() => scrollToSection()}
                >
                  <div className={styles.headerButtonText}>Buy Token</div>
                </Button>
              </Link>
            </Col>
          ) : (
            <></>
          )}
          {width < 992 ? (
            <Col>
              <Image src={votingBanner} className={styles.votingBanner}></Image>
            </Col>
          ) : (
            <></>
          )}
        </div>
      </Col>
      {width < 992 ? (
        <></>
      ) : (
        <Col style={{ textAlign: "end", position: "relative" }}>
          <Image src={votingBanner} className={styles.votingBanner}></Image>
        </Col>
      )}
    </Row>
  );
}

export default VoteHeaderContent;
